export default "__VITE_ASSET__58bf4043__"